

document.addEventListener("DOMContentLoaded",()=>{


/* =====================================
   REVEAL ANIMATIONS
===================================== */


const revealItems = document.querySelectorAll(
  ".vero-product-card, .vero-why-content, .vero-why-media, .vero-club-card, .vero-newsletter-box"
);


const observer = new IntersectionObserver(entries=>{


entries.forEach(entry=>{


if(entry.isIntersecting){

entry.target.classList.add("active");

observer.unobserve(entry.target);

}


});


},{
threshold:.15
});


revealItems.forEach(el=>observer.observe(el));





/* =====================================
   PAGE TRANSITION
===================================== */


document.querySelectorAll(
".vero-wrapper .link-transition"
).forEach(link=>{


link.addEventListener("click",e=>{


e.preventDefault();


document.body.style.transition =
"opacity .35s ease";


document.body.style.opacity="0";


setTimeout(()=>{

window.location=link.href;

},350);


});


});






/* =====================================
   ADD TO CART VERO
===================================== */


document.querySelectorAll(
".vero-cart-button.add-to-cart"
).forEach(btn=>{


btn.addEventListener("click",(e)=>{


e.preventDefault();

e.stopPropagation();



const id = btn.dataset.id;



btn.classList.add("loading");



fetch('/cart/add.js',{

method:'POST',

headers:{

'Content-Type':'application/json'

},

body:JSON.stringify({

id:id,

quantity:1

})

})



.then(()=> fetch(window.location.pathname + '?sections=header'))

.then(res=>res.json())

.then(data=>{


if(data.header){


const parser = new DOMParser();


const doc = parser.parseFromString(
data.header,
'text/html'
);



const newHeader =
doc.querySelector('header.header');


const currentHeader =
document.querySelector('header.header');



if(newHeader && currentHeader){

currentHeader.innerHTML =
newHeader.innerHTML;

}


}


return fetch('/cart.js');


})


.then(res=>res.json())


.then(cart=>{


document.querySelectorAll(

'[data-cart-count], .cart-count-bubble span, .header__icon .badge'

)

.forEach(counter=>{

counter.textContent =
cart.item_count;

});



btn.classList.remove("loading");


btn.classList.add("added");



btn.innerHTML="✓";



setTimeout(()=>{


btn.classList.remove("added");

btn.innerHTML="🛒";


},1200);



})



.catch(()=>{


btn.classList.remove("loading");


});



});


});



});


